export function getHost(key = '__host__', defaultValue = 'web') {
  // getting stored value
  const retrieved = localStorage.getItem(key)
  if(!retrieved) return defaultValue
  return typeof retrieved === 'string' ? retrieved : JSON.parse(retrieved)
}
